import logo from './logo.svg';
import './App.css';
import JitinChawla from './RoutesContainer/RouteContainer';

function App() {
  return (
    <>
      <JitinChawla />
    </>
  );
}

export default App;
